// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Base Layout ===== */
.consulting-page {
  min-height: 100vh;
  background-color: #f3f8f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
}

/* ===== Card Container ===== */
.consulting-card {
  width: 92%;
  max-width: 1100px;
  background-color: #ffffff;
  margin-top: 120px;
  margin-bottom: 80px;
  border-radius: 14px;
  padding: 40px 60px;
  box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.08);
  text-align: center;
  transition: all 0.3s ease;
}

/* ===== Headings ===== */
.consulting-title {
  font-size: 2.3rem;
  font-weight: 700;
  color: #025d3c;
  margin-bottom: 10px;
}

.consulting-desc {
  font-size: 1rem;
  color: #555;
  margin-bottom: 30px;
  line-height: 1.6;
}

/* ===== Toggle Buttons ===== */
.consulting-button-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 30px;
}

.consulting-toggle-btn {
  padding: 12px 18px;
  font-size: 15px;
  font-weight: 500;
  background-color: #f0f0f0;
  color: #333;
  border: 1px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.consulting-toggle-btn:hover {
  background-color: #e9f7f0;
}

.consulting-toggle-btn.active {
  background-color: #025d3c;
  color: #fff;
  border-color: #025d3c;
}

/* ===== PDF Viewer ===== */
.consulting-viewer {
  width: 100%;
  height: 700px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 35px;
}

/* ===== Back Button ===== */
.consulting-back-btn {
  background-color: #025d3c;
  color: #fff;
  border: none;
  padding: 12px 28px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.consulting-back-btn:hover {
  background-color: #038b5a;
  transform: translateY(-2px);
}

/* ===== Responsive Design ===== */

/* Medium Screens (Tablets) */
@media (max-width: 1024px) {
  .consulting-card {
    width: 95%;
    padding: 35px 30px;
    margin-top: 110px;
  }

  .consulting-title {
    font-size: 2rem;
  }

  .consulting-viewer {
    height: 600px;
  }
}

/* Small Devices (Mobile) */
@media (max-width: 768px) {
  .consulting-card {
    width: 95%;
    padding: 25px 20px;
    margin-top: 100px;
  }

  .consulting-title {
    font-size: 1.8rem;
  }

  .consulting-desc {
    font-size: 0.95rem;
  }

  .consulting-button-container {
    flex-direction: column;
    align-items: center;
  }

  .consulting-toggle-btn {
    width: 100%;
  }

  .consulting-viewer {
    height: 480px;
  }

  .consulting-back-btn {
    width: 100%;
  }
}

/* Small Phones (<= 480px) */
@media (max-width: 480px) {
  .consulting-card {
    width: 96%;
    margin-top: 95px;
    padding: 18px;
  }

  .consulting-title {
    font-size: 1.5rem;
  }

  .consulting-desc {
    font-size: 0.9rem;
  }

  .consulting-viewer {
    height: 420px;
  }
}

/* Large Monitors */
@media (min-width: 1440px) {
  .consulting-card {
    max-width: 1300px;
    padding: 50px 70px;
  }

  .consulting-viewer {
    height: 800px;
  }

  .consulting-title {
    font-size: 2.6rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ConsultingTraining/ConsultingTraining.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;EAC5C,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,kCAAkC;;AAElC,6BAA6B;AAC7B;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* ===== Base Layout ===== */\n.consulting-page {\n  min-height: 100vh;\n  background-color: #f3f8f5;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow-x: hidden;\n}\n\n/* ===== Card Container ===== */\n.consulting-card {\n  width: 92%;\n  max-width: 1100px;\n  background-color: #ffffff;\n  margin-top: 120px;\n  margin-bottom: 80px;\n  border-radius: 14px;\n  padding: 40px 60px;\n  box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.08);\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n/* ===== Headings ===== */\n.consulting-title {\n  font-size: 2.3rem;\n  font-weight: 700;\n  color: #025d3c;\n  margin-bottom: 10px;\n}\n\n.consulting-desc {\n  font-size: 1rem;\n  color: #555;\n  margin-bottom: 30px;\n  line-height: 1.6;\n}\n\n/* ===== Toggle Buttons ===== */\n.consulting-button-container {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 30px;\n}\n\n.consulting-toggle-btn {\n  padding: 12px 18px;\n  font-size: 15px;\n  font-weight: 500;\n  background-color: #f0f0f0;\n  color: #333;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.consulting-toggle-btn:hover {\n  background-color: #e9f7f0;\n}\n\n.consulting-toggle-btn.active {\n  background-color: #025d3c;\n  color: #fff;\n  border-color: #025d3c;\n}\n\n/* ===== PDF Viewer ===== */\n.consulting-viewer {\n  width: 100%;\n  height: 700px;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  overflow: hidden;\n  margin-bottom: 35px;\n}\n\n/* ===== Back Button ===== */\n.consulting-back-btn {\n  background-color: #025d3c;\n  color: #fff;\n  border: none;\n  padding: 12px 28px;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.consulting-back-btn:hover {\n  background-color: #038b5a;\n  transform: translateY(-2px);\n}\n\n/* ===== Responsive Design ===== */\n\n/* Medium Screens (Tablets) */\n@media (max-width: 1024px) {\n  .consulting-card {\n    width: 95%;\n    padding: 35px 30px;\n    margin-top: 110px;\n  }\n\n  .consulting-title {\n    font-size: 2rem;\n  }\n\n  .consulting-viewer {\n    height: 600px;\n  }\n}\n\n/* Small Devices (Mobile) */\n@media (max-width: 768px) {\n  .consulting-card {\n    width: 95%;\n    padding: 25px 20px;\n    margin-top: 100px;\n  }\n\n  .consulting-title {\n    font-size: 1.8rem;\n  }\n\n  .consulting-desc {\n    font-size: 0.95rem;\n  }\n\n  .consulting-button-container {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .consulting-toggle-btn {\n    width: 100%;\n  }\n\n  .consulting-viewer {\n    height: 480px;\n  }\n\n  .consulting-back-btn {\n    width: 100%;\n  }\n}\n\n/* Small Phones (<= 480px) */\n@media (max-width: 480px) {\n  .consulting-card {\n    width: 96%;\n    margin-top: 95px;\n    padding: 18px;\n  }\n\n  .consulting-title {\n    font-size: 1.5rem;\n  }\n\n  .consulting-desc {\n    font-size: 0.9rem;\n  }\n\n  .consulting-viewer {\n    height: 420px;\n  }\n}\n\n/* Large Monitors */\n@media (min-width: 1440px) {\n  .consulting-card {\n    max-width: 1300px;\n    padding: 50px 70px;\n  }\n\n  .consulting-viewer {\n    height: 800px;\n  }\n\n  .consulting-title {\n    font-size: 2.6rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
